// import { MONTH_NAMES } from "./HrmData";
// import { buildMonthGridWithAdjacent } from "./HrmPrintHelpers";

// // Epson ePOS-Print web service listens on 8008 by default on TM-series
// // network printers (TM-m30, TM-T88VI/VII, etc.). Your printerIPs storage
// // only keeps a bare IP per device, so this is what's used unless a printer
// // object explicitly carries its own `.port`.
// export const EPSON_DEFAULT_PORT = 80;

// const LINE_WIDTH = 42;
// const LABEL_WIDTH = 20;
// const VALUE_WIDTH = 22;

// const escXml = (value) =>
//   String(value ?? "").replace(
//     /[&<>"']/g,
//     (c) =>
//       ({
//         "&": "&amp;",
//         "<": "&lt;",
//         ">": "&gt;",
//         '"': "&quot;",
//         "'": "&apos;",
//       })[c],
//   );

// const rule = () =>
//   `<text font="font_b" width="1" height="1">${"-".repeat(LINE_WIDTH)}</text><feed line="1"/>`;

// // Small font throughout — headings stay the same physical size as the body
// // text and lean on bold (em) + centering for hierarchy instead of scale.
// const title = (text) =>
//   `<text align="center" font="font_b" width="1" height="1" em="true">${escXml(text)}</text><feed line="1"/>`;

// const subheading = (text) =>
//   `<text align="center" font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

// const sectionHeading = (text) =>
//   `<text font="font_b" width="1" height="1" em="true">${escXml(text)}</text><feed line="1"/>`;

// const plain = (text) =>
//   `<text font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

// /** Right-aligns `value` against a left-aligned `label`, thermal-receipt style. */
// const formatLine = (label, value) => {
//   const paddedLabel = String(label).padEnd(LABEL_WIDTH, " ");
//   const paddedValue = String(value).padStart(VALUE_WIDTH, " ");
//   return `<text font="font_b" width="1" height="1">${escXml(paddedLabel)}${escXml(paddedValue)}</text><feed line="1"/>`;
// };

// /** Splits long free text into LINE_WIDTH-wide chunks, each its own receipt line. */
// const wrapText = (text, width = LINE_WIDTH) => {
//   const words = String(text ?? "").split(/\s+/);
//   const lines = [];
//   let current = "";
//   words.forEach((word) => {
//     const next = current ? `${current} ${word}` : word;
//     if (next.length > width) {
//       if (current) lines.push(current);
//       current = word;
//     } else {
//       current = next;
//     }
//   });
//   if (current) lines.push(current);
//   return lines.length ? lines : [""];
// };

// const wrapAsLines = (text, width = LINE_WIDTH) =>
//   wrapText(text, width)
//     .map((l) => plain(l))
//     .join("");

// const footer = () => `${plain("Thank You!")}<feed line="3"/><cut />`;

// const header = (companyName, reportTitle, dateRangeLabel) => `
//   ${title(companyName)}
//   ${subheading(reportTitle)}
//   ${dateRangeLabel ? subheading(dateRangeLabel) : ""}
//   ${rule()}
// `;

// const dateRangeLabel = (year, month) => {
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
//   const m = MONTH_NAMES[month].slice(0, 3);
//   return `01 ${m} - ${String(daysInMonth).padStart(2, "0")} ${m}, ${year}`;
// };

// const inr = (n) => `Rs.${Number(n || 0).toLocaleString("en-IN")}`;

// // ─── Wraps any built lines-XML into the full ePOS-Print SOAP envelope ─────
// const wrapEnvelope = (linesXml) =>
//   '<?xml version="1.0" encoding="utf-8"?>' +
//   '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
//   "<s:Body>" +
//   '<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">' +
//   linesXml +
//   "</epos-print>" +
//   "</s:Body>" +
//   "</s:Envelope>";

// // ─── 1. Salary Slip ─────────────────────────────────────────────────────
// export const buildSalarySlipReceiptXml = ({
//   employee,
//   slip,
//   year,
//   month,
//   companyName = "Your Company",
// }) => {
//   let lines = header(companyName, "SALARY SLIP", dateRangeLabel(year, month));

//   lines += formatLine("Employee", employee.name);
//   lines += formatLine("Staff ID", employee.staffId || "-");
//   lines += formatLine("Monthly Gross", inr(employee.monthlySalary));
//   lines += rule();

//   lines += sectionHeading("EARNINGS");
//   lines += formatLine(
//     `Present x ${slip.payableDays}d`,
//     `Rs.${slip.dailyRate.toFixed(2)}`,
//   );
//   lines += formatLine("Total Earnings", inr(slip.netPay));
//   lines += rule();

//   lines += formatLine("Days in Month", slip.daysInMonth);
//   lines += formatLine("Present", slip.counts.Present);
//   lines += formatLine("Half-Day", slip.counts["Half-Day"]);
//   lines += formatLine("Absent", slip.counts.Absent);
//   lines += formatLine("Leave", slip.counts.Leave);
//   lines += formatLine("Payable Days", slip.payableDays);
//   lines += rule();

//   lines += formatLine("Deductions", `-${inr(slip.deduction)}`);
//   lines += formatLine("NET PAY", inr(slip.netPay));
//   lines += rule();
//   lines += footer();

//   return wrapEnvelope(lines);
// };

// // ─── 2. Attendance — printed as a real calendar grid ───────────────────
// // Weekday header row (Mo Tu We Th Fr Sa Su), then one row per week; each
// // cell holds the day number plus a single-letter status code, exactly the
// // same Monday→Sunday grid (with faded/blank adjacent-month padding) used
// // on the browser-printed Attendance page.
// const STATUS_CHAR = {
//   Present: "P",
//   Absent: "A",
//   "Half-Day": "H",
//   Leave: "L",
// };

// const CAL_COL_WIDTH = 4; // e.g. "01P " — day (2) + status (1) + padding (1)

// const calHeaderRow = () =>
//   plain(
//     ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]
//       .map((d) => d.padEnd(CAL_COL_WIDTH, " "))
//       .join(""),
//   );

// const calWeekRow = (weekCells, statusByDate) => {
//   const cellText = weekCells
//     .map((cell) => {
//       if (!cell.inMonth) return "".padEnd(CAL_COL_WIDTH, " ");
//       const status = statusByDate[cell.iso];
//       const code = status ? STATUS_CHAR[status] || "?" : "-";
//       return `${String(cell.day).padStart(2, "0")}${code}`.padEnd(
//         CAL_COL_WIDTH,
//         " ",
//       );
//     })
//     .join("");
//   return plain(cellText);
// };

// export const buildAttendanceReceiptXml = ({
//   employee,
//   statusByDate,
//   year,
//   month,
//   companyName = "Your Company",
// }) => {
//   let lines = header(companyName, "ATTENDANCE", dateRangeLabel(year, month));

//   lines += formatLine("Employee", employee.name);
//   lines += formatLine("Staff ID", employee.staffId || "-");
//   lines += rule();

//   const weekRows = buildMonthGridWithAdjacent(year, month);
//   lines += calHeaderRow();
//   weekRows.forEach((week) => {
//     lines += calWeekRow(week, statusByDate);
//   });
//   lines += rule();
//   lines += plain("P=Present A=Absent H=Half-Day L=Leave");

//   const counts = {
//     Present: 0,
//     Absent: 0,
//     "Half-Day": 0,
//     Leave: 0,
//     Unmarked: 0,
//   };
//   weekRows.forEach((week) =>
//     week
//       .filter((c) => c.inMonth)
//       .forEach((cell) => {
//         const status = statusByDate[cell.iso];
//         if (status && counts[status] !== undefined) counts[status] += 1;
//         else counts.Unmarked += 1;
//       }),
//   );

//   lines += rule();
//   lines += sectionHeading("SUMMARY");
//   lines += formatLine("Present", counts.Present);
//   lines += formatLine("Absent", counts.Absent);
//   lines += formatLine("Half-Day", counts["Half-Day"]);
//   lines += formatLine("Leave", counts.Leave);
//   lines += formatLine("Not Marked", counts.Unmarked);
//   lines += rule();
//   lines += footer();

//   return wrapEnvelope(lines);
// };

// // ─── 3. History ──────────────────────────────────────────────────────────
// export const buildHistoryReceiptXml = ({
//   employee,
//   employeeHistory,
//   companyName = "Your Company",
// }) => {
//   let lines = header(companyName, "EDIT HISTORY", null);

//   lines += formatLine("Employee", employee.name);
//   lines += formatLine("Staff ID", employee.staffId || "-");
//   lines += rule();

//   if (!employeeHistory.length) {
//     lines += plain("No edits recorded yet.");
//   } else {
//     employeeHistory.forEach((entry, idx) => {
//       lines += wrapAsLines(entry.description);
//       lines += plain(
//         `  ${new Date(entry.timestamp).toLocaleString("en-IN", {
//           day: "2-digit",
//           month: "short",
//           year: "numeric",
//           hour: "2-digit",
//           minute: "2-digit",
//         })}`,
//       );
//       if (idx < employeeHistory.length - 1) lines += plain(" ");
//     });
//   }

//   lines += rule();
//   lines += footer();

//   return wrapEnvelope(lines);
// };

// // ─── 4. Total Paid ───────────────────────────────────────────────────────
// export const buildTotalPaidReceiptXml = ({
//   employee,
//   paidHistory,
//   year,
//   month,
//   companyName = "Your Company",
// }) => {
//   let lines = header(
//     companyName,
//     "TOTAL PAID",
//     `Upto ${MONTH_NAMES[month].slice(0, 3)} ${year}`,
//   );

//   lines += formatLine("Employee", employee.name);
//   lines += formatLine("Staff ID", employee.staffId || "-");
//   lines += formatLine(
//     "Joined",
//     new Date(paidHistory.joiningDate).toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     }),
//   );
//   lines += rule();

//   paidHistory.monthlySlips.forEach((s) => {
//     lines += formatLine(
//       `${MONTH_NAMES[s.month].slice(0, 3)} ${s.year}`,
//       inr(s.netPay),
//     );
//   });

//   lines += rule();
//   lines += formatLine("Gross Across Period", inr(paidHistory.totalGross));
//   lines += formatLine(
//     "Total Deductions",
//     `-${inr(paidHistory.totalDeduction)}`,
//   );
//   lines += formatLine("TOTAL PAID", inr(paidHistory.totalPaid));
//   lines += rule();
//   lines += footer();

//   return wrapEnvelope(lines);
// };

// // ─── Sends any of the above envelopes to the printer's ePOS-Print service ─
// /**
//  * POSTs a pre-built ePOS-Print SOAP envelope to the printer.
//  * Returns { success: boolean, message?: string } instead of throwing, so
//  * callers can show a toast either way without wrapping every call in try/catch.
//  */
// export const sendEposPrint = async (printerIp, printerPort, requestXml) => {
//   if (!printerIp || !printerPort) {
//     return { success: false, message: "Printer IP or port is missing." };
//   }

//   const url = `http://${printerIp}:${printerPort}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000`;

//   try {
//     const response = await fetch(url, {
//       method: "POST",
//       headers: { "Content-Type": "text/xml; charset=utf-8" },
//       body: requestXml,
//     });

//     if (!response.ok) {
//       return {
//         success: false,
//         message: `Printer responded with status ${response.status}.`,
//       };
//     }
//     return { success: true };
//   } catch (error) {
//     console.error("Epson print error:", error);
//     return {
//       success: false,
//       message: "Could not reach the printer. Check the IP/port and try again.",
//     };
//   }
// };

// ─── Epson ePOS Thermal Receipt Helpers ────────────────────────────────────
// Builds the ePOS-Print XML for each HRM report and sends it straight to a
// networked Epson receipt printer (TM-T88 / TM-m30 etc.) over its built-in
// ePOS-Print web service — no PDF, no browser print dialog involved.
//
// Font size is uniform everywhere (font_b, width=1 height=1). Bold (em) is
// reserved for exactly three things: the Company Name, the report heading
// (SALARY SLIP / ATTENDANCE / EDIT HISTORY / TOTAL PAID), and the "Thank
// You!" footer line — those three also get a touch of letter-spacing so
// they read as headings against the plain body text. Everything else
// (labels, values, calendar grid, section labels like "EARNINGS") stays
// regular weight, normal spacing.
//
// RECEIPT_WIDTH is the printer's actual usable character width per line —
// widen or narrow this to match your paper (48 fits a standard 80mm roll
// printing in font_b; 32 fits 58mm paper). Every column layout below
// (label/value pairs, the calendar grid) is derived from this one number,
// so the content always spans the full printable width instead of leaving
// a blank margin down the right side.
//
// The Attendance receipt renders as a real calendar grid — a weekday header
// row (Mo Tu We Th Fr Sa Su) followed by one row per week, each cell holding
// the day number + a single-letter status code — instead of a plain list of
// "date : status" lines.
//
// One shared `sendEposPrint()` does the actual network call; four builder
// functions (`buildSalarySlipReceiptXml`, `buildAttendanceReceiptXml`,
// `buildHistoryReceiptXml`, `buildTotalPaidReceiptXml`) each turn the same
// data your modal already computes (slip / paidHistory / statusByDate /
// employeeHistory) into a receipt body.
//
// Usage:
//
//   import {
//     sendEposPrint,
//     buildSalarySlipReceiptXml,
//     buildAttendanceReceiptXml,
//     buildHistoryReceiptXml,
//     buildTotalPaidReceiptXml,
//   } from "./EpsonReceiptHelpers";
//
//   const xml = buildSalarySlipReceiptXml({ employee, slip, year, month, companyName });
//   const result = await sendEposPrint(printerIp, printerPort, xml);
//   if (!result.success) show(result.message, "error");

import { MONTH_NAMES } from "./HrmData";
import { buildMonthGridWithAdjacent } from "./HrmPrintHelpers";

// Epson ePOS-Print web service listens on 8008 by default on TM-series
// network printers (TM-m30, TM-T88VI/VII, etc.). Your printerIPs storage
// only keeps a bare IP per device, so this is what's used unless a printer
// object explicitly carries its own `.port`.
export const EPSON_DEFAULT_PORT = 80;

// Usable characters per line at font_b (normal width). 48 covers a standard
// 80mm-wide roll; drop to 32 for 58mm paper.
export const RECEIPT_WIDTH = 48;
const LABEL_WIDTH = 24;
const VALUE_WIDTH = RECEIPT_WIDTH - LABEL_WIDTH;

const escXml = (value) =>
  String(value ?? "").replace(
    /[&<>"']/g,
    (c) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;",
      })[c],
  );

/** Inserts a single space between characters — a light letter-spacing effect for headings. */
// const spaced = (text) => String(text).trim().split("").join(" ");

const rule = () =>
  `<text font="font_b" width="1" height="1">${"-".repeat(RECEIPT_WIDTH)}</text><feed line="1"/>`;

// ─── The only three bold, letter-spaced lines on any receipt ─────────────
const title = (text) =>
  `<text align="center" font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

const reportHeading = (text) =>
  `<text align="center" font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

const thankYouLine = () =>
  `<text align="center" font="font_b" width="1" height="1">${escXml("Thank You!")}</text><feed line="1"/>`;

// ─── Everything else: regular weight, normal spacing ──────────────────────
const subheading = (text) =>
  `<text align="center" font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

const sectionHeading = (text) =>
  `<text font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

const plain = (text) =>
  `<text font="font_b" width="1" height="1">${escXml(text)}</text><feed line="1"/>`;

/** Right-aligns `value` against a left-aligned `label`, spanning the full receipt width. */
const formatLine = (label, value) => {
  const paddedLabel = String(label).padEnd(LABEL_WIDTH, " ");
  const paddedValue = String(value).padStart(VALUE_WIDTH, " ");
  return `<text font="font_b" width="1" height="1">${escXml(paddedLabel)}${escXml(paddedValue)}</text><feed line="1"/>`;
};

/** Splits long free text into RECEIPT_WIDTH-wide chunks, each its own receipt line. */
const wrapText = (text, width = RECEIPT_WIDTH) => {
  const words = String(text ?? "").split(/\s+/);
  const lines = [];
  let current = "";
  words.forEach((word) => {
    const next = current ? `${current} ${word}` : word;
    if (next.length > width) {
      if (current) lines.push(current);
      current = word;
    } else {
      current = next;
    }
  });
  if (current) lines.push(current);
  return lines.length ? lines : [""];
};

const wrapAsLines = (text, width = RECEIPT_WIDTH) =>
  wrapText(text, width)
    .map((l) => plain(l))
    .join("");

const footer = () => `${thankYouLine()}<feed line="3"/><cut />`;

const header = (companyName, reportTitle, dateRangeLabel) => `
  ${title(companyName)}
  ${reportHeading(reportTitle)}
  ${dateRangeLabel ? subheading(dateRangeLabel) : ""}
  ${rule()}
`;

const dateRangeLabel = (year, month) => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const m = MONTH_NAMES[month].slice(0, 3);
  return `01 ${m} - ${String(daysInMonth).padStart(2, "0")} ${m}, ${year}`;
};

const inr = (n) => `Rs.${Number(n || 0).toLocaleString("en-IN")}`;

// ─── Wraps any built lines-XML into the full ePOS-Print SOAP envelope ─────
const wrapEnvelope = (linesXml) =>
  '<?xml version="1.0" encoding="utf-8"?>' +
  '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
  "<s:Body>" +
  '<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">' +
  linesXml +
  "</epos-print>" +
  "</s:Body>" +
  "</s:Envelope>";

// ─── 1. Salary Slip ─────────────────────────────────────────────────────
export const buildSalarySlipReceiptXml = ({
  employee,
  slip,
  year,
  month,
  companyName = "Your Company",
}) => {
  let lines = header(companyName, "SALARY SLIP", dateRangeLabel(year, month));

  lines += formatLine("Employee", employee.name);
  lines += formatLine("Staff ID", employee.staffId || "-");
  lines += formatLine("Monthly Gross", inr(employee.monthlySalary));
  lines += rule();

  lines += sectionHeading("EARNINGS");
  lines += formatLine(
    `Present x ${slip.payableDays}d`,
    `Rs.${slip.dailyRate.toFixed(2)}`,
  );
  lines += formatLine("Total Earnings", inr(slip.netPay));
  lines += rule();

  lines += formatLine("Days in Month", slip.daysInMonth);
  lines += formatLine("Present", slip.counts.Present);
  lines += formatLine("Half-Day", slip.counts["Half-Day"]);
  lines += formatLine("Absent", slip.counts.Absent);
  lines += formatLine("Leave", slip.counts.Leave);
  lines += formatLine("Payable Days", slip.payableDays);
  lines += rule();

  lines += formatLine("Deductions", `-${inr(slip.deduction)}`);
  lines += formatLine("NET PAY", inr(slip.netPay));
  lines += rule();
  lines += footer();

  return wrapEnvelope(lines);
};

// ─── 2. Attendance — printed as a real calendar grid ───────────────────
// Weekday header row (Mo Tu We Th Fr Sa Su), then one row per week; each
// cell holds the day number plus a single-letter status code, exactly the
// same Monday→Sunday grid (with faded/blank adjacent-month padding) used
// on the browser-printed Attendance page. Column width is derived from
// RECEIPT_WIDTH so the grid spans the full line instead of hugging the left.
const STATUS_CHAR = {
  Present: "P",
  Absent: "A",
  "Half-Day": "H",
  Leave: "L",
};

const CAL_COL_WIDTH = Math.floor(RECEIPT_WIDTH / 7); // e.g. 6 at width 48 — "01P   "

const calHeaderRow = () =>
  plain(
    ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]
      .map((d) => d.padEnd(CAL_COL_WIDTH, " "))
      .join(""),
  );

const calWeekRow = (weekCells, statusByDate) => {
  const cellText = weekCells
    .map((cell) => {
      if (!cell.inMonth) return "".padEnd(CAL_COL_WIDTH, " ");
      const status = statusByDate[cell.iso];
      const code = status ? `" "${STATUS_CHAR[status]}` || "?" : "-";
      return `${String(cell.day).padStart(2, "0")}${code}`.padEnd(
        CAL_COL_WIDTH,
        " ",
      );
    })
    .join("");
  return plain(cellText);
};

export const buildAttendanceReceiptXml = ({
  employee,
  statusByDate,
  year,
  month,
  companyName = "Your Company",
}) => {
  let lines = header(companyName, "ATTENDANCE", dateRangeLabel(year, month));

  lines += formatLine("Employee", employee.name);
  lines += formatLine("Staff ID", employee.staffId || "-");
  lines += rule();

  const weekRows = buildMonthGridWithAdjacent(year, month);
  lines += calHeaderRow();
  weekRows.forEach((week) => {
    lines += calWeekRow(week, statusByDate);
  });
  lines += rule();
  lines += plain(
    "P = Present, A = Absent, H = Half-Day, L = Leave, - = Unmarked",
  );

  const counts = {
    Present: 0,
    Absent: 0,
    "Half-Day": 0,
    Leave: 0,
    Unmarked: 0,
  };
  weekRows.forEach((week) =>
    week
      .filter((c) => c.inMonth)
      .forEach((cell) => {
        const status = statusByDate[cell.iso];
        if (status && counts[status] !== undefined) counts[status] += 1;
        else counts.Unmarked += 1;
      }),
  );

  lines += rule();
  lines += sectionHeading("SUMMARY");
  lines += formatLine("Present", counts.Present);
  lines += formatLine("Absent", counts.Absent);
  lines += formatLine("Half-Day", counts["Half-Day"]);
  lines += formatLine("Leave", counts.Leave);
  lines += formatLine("Not Marked", counts.Unmarked);
  lines += rule();
  lines += footer();

  return wrapEnvelope(lines);
};

// ─── 3. History ──────────────────────────────────────────────────────────
export const buildHistoryReceiptXml = ({
  employee,
  employeeHistory,
  companyName = "Your Company",
}) => {
  let lines = header(companyName, "EDIT HISTORY", null);

  lines += formatLine("Employee", employee.name);
  lines += formatLine("Staff ID", employee.staffId || "-");
  lines += rule();

  if (!employeeHistory.length) {
    lines += plain("No edits recorded yet.");
  } else {
    employeeHistory.forEach((entry, idx) => {
      lines += wrapAsLines(entry.description);
      lines += plain(
        `  ${new Date(entry.timestamp).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}`,
      );
      if (idx < employeeHistory.length - 1) lines += plain(" ");
    });
  }

  lines += rule();
  lines += footer();

  return wrapEnvelope(lines);
};

// ─── 4. Total Paid ───────────────────────────────────────────────────────
export const buildTotalPaidReceiptXml = ({
  employee,
  paidHistory,
  year,
  month,
  companyName = "Your Company",
}) => {
  let lines = header(
    companyName,
    "TOTAL PAID",
    `Upto ${MONTH_NAMES[month].slice(0, 3)} ${year}`,
  );

  lines += formatLine("Employee", employee.name);
  lines += formatLine("Staff ID", employee.staffId || "-");
  lines += formatLine(
    "Joined",
    new Date(paidHistory.joiningDate).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }),
  );
  lines += rule();

  paidHistory.monthlySlips.forEach((s) => {
    lines += formatLine(
      `${MONTH_NAMES[s.month].slice(0, 3)} ${s.year}`,
      inr(s.netPay),
    );
  });

  lines += rule();
  lines += formatLine("Gross Across Period", inr(paidHistory.totalGross));
  lines += formatLine(
    "Total Deductions",
    `-${inr(paidHistory.totalDeduction)}`,
  );
  lines += formatLine("TOTAL PAID", inr(paidHistory.totalPaid));
  lines += rule();
  lines += footer();

  return wrapEnvelope(lines);
};

// ─── Sends any of the above envelopes to the printer's ePOS-Print service ─
/**
 * POSTs a pre-built ePOS-Print SOAP envelope to the printer.
 * Returns { success: boolean, message?: string } instead of throwing, so
 * callers can show a toast either way without wrapping every call in try/catch.
 */
export const sendEposPrint = async (printerIp, printerPort, requestXml) => {
  if (!printerIp || !printerPort) {
    return { success: false, message: "Printer IP or port is missing." };
  }

  const url = `http://${printerIp}:${printerPort}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/xml; charset=utf-8" },
      body: requestXml,
    });

    if (!response.ok) {
      return {
        success: false,
        message: `Printer responded with status ${response.status}.`,
      };
    }
    return { success: true };
  } catch (error) {
    console.error("Epson print error:", error);
    return {
      success: false,
      message: "Could not reach the printer. Check the IP/port and try again.",
    };
  }
};
